const NODE_ENV = process.env.NODE_ENV; //vue-cli3.0在src里使用环境变量需要加VUE_APP_前缀

// 正式域名
var DOMAIN_R = {
    // 新接口
    baseUrl: "https://ict.pcauto.com.cn",
};

//开发环境域名
var DOMAIN_T = {
    // 新接口
    baseUrl: "",
};

//qa测试域名
var DOMAIN_Q = {
    // 新接口
    baseUrl: "https://t-ict.pcauto.com.cn",
};

const DOMAIN = NODE_ENV == "production" ? DOMAIN_R : NODE_ENV == "qa" ? DOMAIN_Q : DOMAIN_T;
const CONFIG = {
    // 开发环境
    development: {
        //首页测评报告内容
        getEvaluationIndex: DOMAIN.baseUrl + "/data/all.json",
        //测评报告详情页
        getEvaluationDetail: DOMAIN.baseUrl + "/data",
        //首页顶部视频内容
        getIndexVideo: DOMAIN.baseUrl + "/data/videoList.json",
        //排行榜精华集选
        getRankContent: DOMAIN.baseUrl + "/data/essenceCollections.json",
        //相关内容推荐
        getRelatedContent: DOMAIN.baseUrl + "/data/jizhiContents.json",
        
    },

    // 测试环境
    qa: {
        //首页测评报告内容
        getEvaluationIndex: DOMAIN.baseUrl + "/data/all.json",
        //测评报告详情页
        getEvaluationDetail: DOMAIN.baseUrl + "/data",
        //首页顶部视频内容
        getIndexVideo: DOMAIN.baseUrl + "/data/videoList.json",
        //排行榜精华集选
        getRankContent: DOMAIN.baseUrl + "/data/essenceCollections.json",
        //相关内容推荐
        getRelatedContent: DOMAIN.baseUrl + "/data/jizhiContents.json",
    },
    
    // 正式环境
    production: {
        //首页测评报告内容
        getEvaluationIndex: DOMAIN.baseUrl + "/data/all.json",
        //测评报告详情页
        getEvaluationDetail: DOMAIN.baseUrl + "/data",
        //首页顶部视频内容
        getIndexVideo: DOMAIN.baseUrl + "/data/videoList.json",
        //排行榜精华集选
        getRankContent: DOMAIN.baseUrl + "/data/essenceCollections.json",
        //相关内容推荐
        getRelatedContent: DOMAIN.baseUrl + "/data/jizhiContents.json",
    }
};

export function getDomain(key) {
    const domain = CONFIG[process.env.NODE_ENV];
    if (!domain) return "";

    return domain[key] || "";
}
const common_session_id = NODE_ENV == "production" ? "common_session_id" : "common_session_id1";

export function getCommonSessionId() {
    return common_session_id;
}

export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}


// WEBPACK FOOTER //
// ./src/pc.config.js